import { render, staticRenderFns } from "./about-me.vue?vue&type=template&id=9f2f2550&"
import script from "./about-me.vue?vue&type=script&lang=js&"
export * from "./about-me.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports